module.exports = __webpack_public_path__ + "img/fun-3.afb76da7.png";